import { useMemo } from 'react';
import { buildLimitedTimeOfferDiscountByTierName } from 'pricing-pages-ui-hsoc/components/merch-card-grid/hsocCardBadges';
import { useHsocPublicUpsellDiscountForTerm } from './useHsocPublicUpsellDiscountForTerm';

/*
 * The starter limited-time-offer discount, keyed by tier, shared by the merch
 * cards and the feature-table header so both surface the same badge from a
 * single source. Public visitors are always anonymous (never a paid portal),
 * so isPaidPortal is false. Mirrors the in-app useHsocInAppLimitedTimeOfferByTier.
 */
export function useHsocPublicLimitedTimeOfferByTier(starterApiName, selectedTerm) {
  const starterDiscountPercentage = useHsocPublicUpsellDiscountForTerm(starterApiName !== null && starterApiName !== void 0 ? starterApiName : '', {
    term: selectedTerm,
    skip: !starterApiName
  });
  return useMemo(() => buildLimitedTimeOfferDiscountByTierName({
    isPaidPortal: false,
    starterDiscountPercentage
  }), [starterDiscountPercentage]);
}